import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { userPermissionsSelector, activeProfileSelector } from "store/user"
import { routes } from "./routes"
import { getStaffUserDefaultRoute } from "utils/permissionRedirect"

const PermissionBasedRedirect = () => {
  const navigate = useNavigate()
  const { role } = useSelector((store) => store.user)
  const permissions = useSelector(userPermissionsSelector)
  const activeProfile = useSelector(activeProfileSelector)

  useEffect(() => {
    if (!role) {
      return
    }

    if (role === "guide_user") {
      navigate(routes.guideAIDashboardPath(), { replace: true })
    } else if (role === "staff_user") {
      if (!permissions || Object.keys(permissions).length === 0) {
        return
      }
      const defaultRoute = getStaffUserDefaultRoute(permissions)
      navigate(defaultRoute, { replace: true })
    } else {
      navigate(routes.guideAIDashboardPath(), { replace: true })
    }
  }, [role, permissions, activeProfile, navigate])

  return null
}

export default PermissionBasedRedirect
